export default {
  language: "Language",
  login: "Login",
  logout: "Logout",
  mypage: 'Mypage',
  privatelegal: "Privacy Policy",
  email: "Email",
  password: "password",
  username: "name",
  noise: "Noise",
  reduction: "Reduction",
  nr: "Noise Reduction",
  recording: "Recording",
  encoding: "Encoding",
  edit: "Edit",
  editing: "Editing",
  pricing: "Price",
  web: "Web",
  audio: "Audio",
  advertise: "Advertising",
  nrb1: "Usage",
  nrb2: "Noise Reduction Quality",
  nrb3: "Easy to use",
  nrb4: "Safe privacy protection",
  nrb5: "Lightweight local resource",
  nrb6: "Web & App",
  recb1: "Usage",
  recb2: "Realtime Display",
  recb3: "Easy to use",
  recb4: "Safe privacy protection",
  recb5: "Various Codec",
  recb6: "Web & App",
  editb1: "Usage",
  editb2: "Mouse Usage",
  editb3: "Easy to use",
  editb4: "Safe Edit",
  editb5: "Functions",
  editb6: "Web & App",
  logout_confirm: "Are you sure to logout ?",
  phrase: {
    easyRecording: "Easily record on the web without installing a program",
    startRecording: "Click the red button For Recording ",
    record1: "Click the button to start recording.",
    record2: "Listen to the recorded voice.",
    record3: "Click the download button to save file",
    deeplearning: "You can remove noise from speech using deep learning technology",
    easyEncoding: "Easily encode audio file on the web.",
    startEncoding: "Upload the audio file you want to encode from.",
    encode1: "Upload audio file you want to encode or transcode.",
    encode2: "Start encoding with selected options.",
    encode3: "Download resulting audio file.",
    upload: 'Upload the audio file you want to remove noise from.',
    Processing: 'Restores clear voice using deep learning.',
    Download: 'Download to local folder of your PC.',
    editTitle: "Easily edit on the web without installing a program",
    editDirection1: "Select the input file,",
    editDirection2: " or Drag&Drop it on the picture window.",
    editWheel: "Select with the mouse and use the button below (mouse wheel available)",
    nrb1_sub: "Drag and drop audio files into the box, or click the box to select a file through Explorer. After checking the uploaded file, click the noise reduction button to automatically remove the noise. Preview the finished file and download it.",
    nrb2_sub: "Voice Noise Reduction provides a noise reduction service using deep learning artificial intelligence. Installing audio-related programs and following the tutorials available online provides higher noise reduction performance than traditional methods of removing noise, and the quality of the results is excellent.",
    nrb3_sub: "Easily and easily denoise audio files with just a few clicks. Unlike the traditional method of installing audio programs, there is no need to install a separate program, and if there is no problem in the network environment, you can check the result within tens of seconds.",
    nrb4_sub: "The uploaded original file will be deleted immediately after the noise removal operation is completed. The result file is also permanently deleted from the server after 1 hour. No one has access to your files, and your personal information is secure.",
    nrb5_sub: "Voice Noise Reduction can be used anywhere with an internet connection. All processing through deep learning is done in the cloud. Therefore, it does not consume the resources of your computer.",
    nrb6_sub: "Voice Noise Reduction can be easily used through the web and can also be used as a mobile application. The mobile application focuses on voice recording and noise reduction, and acts as an easy-to-use, high-performance recorder.",

    recb1_sub: "Click the Record button and start recording. A microphone device must be connected to the computer. You must also allow browser access to the microphone device. Set up the codec before starting to record.",
    recb2_sub: "Check if the recording is progressing smoothly through the waveform that changes in real time.",
    recb3_sub: "Record easily and conveniently with just a few clicks. Unlike the conventional method of installing a recording program, there is no need to install a separate program.",
    recb4_sub: "Recording takes place only on your computer. As they are not uploaded to the cloud, no external users can access your recordings and your personal information is secure.",
    recb5_sub: "You can record by setting various formats, sample rates, bit rates and channels. If you do not make detailed settings, the recording will be set to the optimum state for voice and file storage.",
    recb6_sub: "Audio Noise Reduction can be easily used through WEB and can also be used as a mobile application. The mobile application focuses on voice recording and noise reduction, and acts as an easy-to-use, high-performance recorder.",

    editb1_sub: "Drag and drop an audio file into the box or select a file to start editing. Click and drag the mouse to select a section. You can perform various actions.",
    editb2_sub: "On the waveform screen, you can zoom in and out of the waveform using the mouse wheel. Move the time of the waveform by dragging the label area of the time axis with the mouse. You can adjust the y-axis level by using the wheel in the label area of the y-axis.",
    editb3_sub: "No program download and installation is required. Select files right from the web and edit audio through intuitive and simple buttons",
    editb4_sub: "The files to be edited are only made on the user's computer. As they are not uploaded to the cloud, no external users can access your recordings and can use them freely without login.",
    editb5_sub: "Unlike traditional audio editors that are complex, web audio editing services are implemented mainly for essential functions.",
    editb6_sub: "Audio Noise Reduction can be easily used through WEB and can also be used as a mobile application. The mobile application focuses on voice recording and noise reduction, and acts as an easy-to-use, high-performance recorder.",

  }

};
